// core
import { Component, Input, OnInit } from '@angular/core';

// services
import { RaptorStepDataService } from '../../services/raptor-step-data.service';

@Component({
  selector: 'open-raptor-flow-banner',
  templateUrl: './raptor-flow-banner.component.html',
  styleUrls: ['./raptor-flow-banner.component.scss']
})
export class RaptorFlowBannerComponent implements OnInit {
  @Input() componentDetails: any;
  formData: any;

  constructor(
    private raptorStepDataService: RaptorStepDataService
  ) {}

  ngOnInit(): void {
    this.formData = this.raptorStepDataService.get();
  }

}
